<template>
  <div id="teachers" >
    <div id="language_div" @click="changeLanguage">{{language}}</div>

    <div v-show="language === '中文'">

    </div>
    <div v-show="language === 'English'">

    </div>

    <div v-if="!isMobile" style="display: grid; grid-template-columns: 1fr 3fr; gap: 10px; height: 60%;">

  <!-- 图片部分 -->
  <div style="margin-top: 0px ;text-align: left; display: flex; justify-content: center; align-items: center;">
    <img src="../assets/tutor_2.jpg" height="320px" width="240px">
  </div>

  <!-- 文本内容部分 -->
  <div style="text-align: left; margin-top: 15%; margin-left: 2%;">
    <!-- 中文部分 -->
    <p style="font-size: 16px; font-family: 'Arial'; margin-left: 0.5%; margin-top: 90px; margin-bottom: 0px" v-show="language === '中文'">
     <b style="font-size: 20px;"> Xiangyu Li</b> <br>
Ph.D., Associate Professor <br>
School of Software Engineering, Beijing Jiaotong University <br>
Room 709, Yifu Building, Beijing Jiaotong University, Beijing 100044, China <br>
Email: lixiangyu@bjtu.edu.cn
    </p>

    <!-- 英文部分 -->
    <p style="font-size: 16px; font-family: 'Arial'; margin-left: 5px; margin-top: 55px; margin-bottom: 0px" v-show="language === 'English'">
       <b style="font-size: 20px;">李翔宇</b><br>
      博士，副教授<br>
北京交通大学软件学院<br>
中国自动化学会智能健康与生物信息学专委会委员<br>
中国人工智能学会生物信息学与人工生命专委会委员  <br>
通讯地址：北京交通大学逸夫楼709 
邮编100044           <br>
Email: lixiangyu@bjtu.edu.cn
    </p>
  </div>
</div>


<!-- 手机布局 -->
<div v-else style="display: flex; flex-direction: column;">
  <div style="margin-top: 24px ;text-align: left; display: flex; justify-content: center; align-items: center;">
    <img src="../assets/tutor_2.jpg" height="320px" width="240px">
  </div>

  <!-- 文本内容部分 -->
  <div style="text-align: center; margin-top: 0%; margin-left: 2%;">
    <!-- 中文部分 -->
    <p style="font-size: 16px;  font-family: 'Arial';margin: auto;margin-top: 10px;" v-show="language === '中文'">
      <b style="font-size: 18px;">Xiangyu Li</b>  <br>
Ph.D., Associate Professor <br>
School of Software Engineering, Beijing Jiaotong University <br>
Room 709, Yifu Building, Beijing Jiaotong University, Beijing 100044, China <br>
Email: lixiangyu@bjtu.edu.cn
    </p>

    <!-- 英文部分 -->
    <p style="font-size: 16px; font-family: 'Arial'; margin: auto; margin-top: 10px;" v-show="language === 'English'">
      <b style="font-size: 18px;">李翔宇</b> <br>
      博士，副教授<br>
北京交通大学软件学院<br>

<p style="text-align: center; width: 80%;margin: auto; margin-top: 10px;" v-show="language === 'English'">
中国自动化学会智能健康与生物信息学专委会委员<br>
中国人工智能学会生物信息学与人工生命专委会委员  <br>
通讯地址：北京交通大学逸夫楼709 
邮编100044           <br>
Email: lixiangyu@bjtu.edu.cn
</p>

    </p>
  </div>
</div>


    <div v-if="!isMobile" v-show="language === '中文'" style="font-family: 'Arial'; font-size: 30px; text-align: left">
      <ul style="padding:0px">

        <li style="list-style-type: none;">
          <h4> Work Experience</h4>
          <div style="font-size: 16px">
<div style="display: grid; grid-template-columns: 230px 1fr; gap: 10px;">
      <div style="text-align: left;">Since 2023.12</div>
      <pre style="text-align: left; font-family: 'Arial'; font-size: 16px; margin-top: 0px; margin-bottom: 0px; height: 80px">
        <b>Associate Professor</b>
        School of Software Engineering, Beijing Jiaotong University
      </pre>
  </div>
  <div style="display: grid; grid-template-columns: 230px 1fr; gap: 10px;">
      <div style="text-align: left;">2023.01-2024.01</div>
      <pre style="text-align: left; font-family: 'Arial'; font-size: 16px; margin-top: 0px; margin-bottom: 0px; height: 80px">
        <b>Visiting Scientist (CSC scholarship)</b>
        Welcome Trust Sanger Institute, Cambridge, UK
      </pre>
  </div>

  <div style="display: grid; grid-template-columns: 230px 1fr; gap: 10px;">
      <div style="text-align: left;">2019.09-2023.12</div>
      <pre style="text-align: left; font-family: 'Arial'; font-size: 16px; margin-top: 0px; margin-bottom: 0px; height: 80px">
        <b>Assistant Professor</b>
        School of Software Engineering,Beijing Jiaotong University
      </pre>
  </div>
</div>
        </li>




        <li style="list-style-type: none;">
          <h4> Education Experience</h4>
          <div style="font-size: 16px">
  <div style="display: grid; grid-template-columns: 230px 1fr; gap: 10px; margin-bottom: 15px;">
      <div style="text-align: left;">2013.09-2019.07</div>
      <pre style="text-align: left; font-family: 'Arial'; font-size: 16px; margin-top: 0px; margin-bottom: 0px; height: 80px">
        <b>Ph.D. in Control Science and Engineering (Area: Bioinformatics)</b>
        Department of Automation, Tsinghua University
        Supervisor: Prof. Xuegong Zhang & Prof. Michael Q. Zhang
      </pre>
  </div>
  <div style="display: grid; grid-template-columns: 230px 1fr; gap: 10px;">
      <div style="text-align: left;">2009.09-2013.07</div>
      <pre style="text-align: left; font-family: 'Arial'; font-size: 16px; margin-top: 0px; margin-bottom: 0px; height: 80px">
        <b>B.S. in Statistics</b>
        School of Mathematics, Jilin University
      </pre>
  </div>

</div>

        </li>

        <li style="list-style-type: none;">
          <h4>Grants (PI)</h4>
              <p style="height: 40px; text-align: left; font-size: 16px; margin:0px;">
                <b>National Natural Science Foundation of China</b>, Computational methodology of
                integrating single cell RNA-seq data with spatially-resolved transcriptomic data for cell
                heterogeneous interpretation
              </p>
              <p style="height:40px ;text-align: left; font-size: 16px; margin-top:25px;margin-bottom: 0px">
                <b>Fundamental Research Funds for the Central Universities</b>, Representation learning
                for single-cell omics data
              </p>
        </li>
        <li style="list-style-type: none;">
          <h4>Teaching</h4>
          <ul style="font-size: 16px;margin: 0; text-align: left; padding:0px">
            <li style="list-style-type: none;">
              <p style="height: 40px; margin:0px; text-align: left; font-size: 16px; margin-bottom: 0px">
                Foundation of Artificial Intelligence (Undergraduate), Instructor
              </p>
            </li>
            <li style="list-style-type: none;">
              <p style="height: 40px;margin:0px; text-align: left; font-size: 16px; margin-bottom: 0px">
                Data Science and Knowledge Discovery (Graduate), Instructor
              </p>
            </li>
            <li style="list-style-type: none;">
              <p style="height: 40px;margin:0px; text-align: left; font-size: 16px; margin-bottom: 0px">
                Statistical Methods with Applications (2014, 2015) Teaching assistant, Tsinghua University
              </p>
            </li>
          </ul>
        </li>
        <li style="list-style-type: none;">
          <h4>Presentations</h4>
          <div style="font-size: 16px">
  <!-- 第一行内容 -->
  <div style="display: grid; grid-template-columns: 100px 1fr; gap: 10px;">
      <div style="text-align: left;">2021.07</div>
      <pre style="height:40px; text-align: left; font-family: 'Arial'; font-size: 16px; margin-top: 0px; margin-bottom: 0px">
          Invited talk, Chinese Society of Biotechnology Young Scientists Forum V
      </pre>
  </div>
  
  <!-- 第二行内容 -->
  <div style="display: grid; grid-template-columns: 100px 1fr; gap: 10px;">
      <div style="text-align: left;">2021.01</div>
      <pre style="height:40px; text-align: left; font-family: 'Arial'; font-size: 16px; margin-top: 0px; margin-bottom: 0px">
          Invited talk, Chinese Academy of Medical Sciences & Peking Union Medical College
      </pre>
  </div>
  
  <!-- 第三行内容 -->
  <div style="display: grid; grid-template-columns: 100px 1fr; gap: 10px;">
      <div style="text-align: left;">2019.04</div>
      <pre style="height:40px; text-align: left; font-family: 'Arial'; font-size: 16px; margin-top: 0px; margin-bottom: 0px">
          Invited talk, Department of Medical informatics, Peking University Health Science Center
      </pre>
  </div>
  
  <!-- 第四行内容 -->
  <div style="display: grid; grid-template-columns: 100px 1fr; gap: 10px;">
      <div style="text-align: left;">2019.02</div>
      <pre style="height:40px; text-align: left; font-family: 'Arial'; font-size: 16px; margin-top: 0px; margin-bottom: 0px">
          Invited talk, Department of Medical informatics, Peking University Health Science Center
      </pre>
  </div>
  
  <!-- 第五行内容 -->
  <div style="display: grid; grid-template-columns: 100px 1fr; gap: 10px;">
      <div style="text-align: left;">2019.01</div>
      <pre style="height:40px; text-align: left; font-family: 'Arial'; font-size: 16px; margin-top: 0px; margin-bottom: 0px">
          Invited talk, Beijing Proteome Research Center
      </pre>
  </div>
  
  <!-- 第六行内容 -->
  <div style="display: grid; grid-template-columns: 100px 1fr; gap: 10px;">
      <div style="text-align: left;">2018.11</div>
      <pre style="height:40px; text-align: left; font-family: 'Arial'; font-size: 16px; margin-top: 0px; margin-bottom: 0px">
          Poster, Cold Spring Harbor Asia meeting on Frontiers in Single cell Genomics
      </pre>
  </div>
  
  <!-- 第七行内容 -->
  <div style="display: grid; grid-template-columns: 100px 1fr; gap: 10px;">
      <div style="text-align: left;">2018.10</div>
      <pre style="height:40px; text-align: left; font-family: 'Arial'; font-size: 16px; margin-top: 0px; margin-bottom: 0px">
          Invited talk, Department of Medical informatics, Peking University Health Science Center
      </pre>
  </div>
  
  <!-- 第八行内容 -->
  <div style="display: grid; grid-template-columns: 100px 1fr; gap: 10px;">
      <div style="text-align: left;">2018.08</div>
      <pre style="height:40px; text-align: left; font-family: 'Arial'; font-size: 16px; margin-top: 0px; margin-bottom: 0px">
          Talk & Poster, Pilot Projects for a Human Cell Atlas Europe Retreat
      </pre>
  </div>
  
  <!-- 第九行内容 -->
  <div style="display: grid; grid-template-columns: 100px 1fr; gap: 10px;">
      <div style="text-align: left;">2018.04</div>
      <pre style="height:40px; text-align: left; font-family: 'Arial'; font-size: 16px; margin-top: 0px; margin-bottom: 0px">
          Invited talk, Department of Medical informatics, Peking University Health Science Center
      </pre>
  </div>
  
  <!-- 第十行内容 -->
  <div style="display: grid; grid-template-columns: 100px 1fr; gap: 10px;">
      <div style="text-align: left;">2017.11</div>
      <pre style="height:40px; text-align: left; font-family: 'Arial'; font-size: 16px; margin-top: 0px; margin-bottom: 0px">
          Invited talk, Institute of Computing Technology, Chinese Academy of Sciences
      </pre>
  </div>
  
  <!-- 第十一行内容 -->
  <div style="display: grid; grid-template-columns: 100px 1fr; gap: 10px;">
      <div style="text-align: left;">2016.11</div>
      <pre style="height:40px; text-align: left; font-family: 'Arial'; font-size: 16px; margin-top: 0px; margin-bottom: 0px">
          Poster, Cold Spring Harbor Asia meeting on Frontiers in Single cell Genomics
      </pre>
  </div>
</div>

        </li>
      </ul>
    </div>

<!-- 手机布局 -->
<div v-else v-show="language === '中文'">
  <ul style="padding:0px">

<li style="list-style-type: none;">
  <h4> Work Experience</h4>
  <div style="font-size: 16px">
<div style="display: flex;flex-direction: column;">
    <div style="text-align: left;"><b>· Since 2023.12</b> </div>
<pre style="text-align: left; font-family: 'Arial'; font-size: 16px; margin-top: 0px; margin-bottom: 0px; height: 120px;white-space: pre-wrap;">
<b>Associate Professor</b>
School of Software Engineering,Beijing Jiaotong University
</pre>
</div>

<div style="display: flex;flex-direction: column;">
<div style="text-align: left;"><b>· 2023.01-2024.01</b></div>
<pre style="text-align: left; font-family: 'Arial'; font-size: 16px; margin-top: 0px; margin-bottom: 0px; height: 100px;white-space: pre-wrap;">
<b>Visiting Scientist (CSC scholarship)</b>
Welcome Trust Sanger Institute, Cambridge, UK
</pre>
</div>

<div style="display: flex;flex-direction: column;margin-top: 20px;">
<div style="text-align: left;"><b>· 2019.09-2023.12</b> </div>
<pre style="text-align: left; font-family: 'Arial'; font-size: 16px; margin-top: 0px; margin-bottom: 0px; height: 110px;white-space: pre-wrap;">
<b>Assistant Professor</b>
School of Software Engineering,Beijing Jiaotong University
</pre>
</div>

</div>
</li>




<li style="list-style-type: none;">
  <h4> Education Experience</h4>
  <div style="font-size: 16px">
<div style="display: flex;flex-direction: column;">
<div style="text-align: left;"><b>· 2013.09-2019.07</b></div>
<pre style="text-align: left; font-family: 'Arial'; font-size: 16px; margin-top: 0px; margin-bottom: 0px; height: 200px;white-space: pre-wrap;">
<b>Ph.D. in Control Science and Engineering (Area: Bioinformatics)</b>
Department of Automation, Tsinghua University
Supervisor: Prof. Xuegong Zhang & Prof. Michael Q. Zhang
</pre>
</div>

<div style="display: flex;flex-direction: column;">
<div style="text-align: left;"><b>· 2009.09-2013.07</b></div>
<pre style="text-align: left; font-family: 'Arial'; font-size: 16px; margin-top: 0px; margin-bottom: 0px; height: 100px;white-space: pre-wrap;">
<b>B.S. in Statistics</b>
School of Mathematics, Jilin University
</pre>
</div>

</div>

</li>

<li style="list-style-type: none;">
  <h4>Grants (PI)</h4>
      <p style="height: 145px; text-align: left; font-size: 16px; margin:0px;">
        <b>National Natural Science Foundation of China</b>, Computational methodology of
        integrating single cell RNA-seq data with spatially-resolved transcriptomic data for cell
        heterogeneous interpretation
      </p>
      <p style="height:100px ;text-align: left; font-size: 16px; margin-top:25px;margin-bottom: 0px">
        <b>Fundamental Research Funds for the Central Universities</b>, Representation learning
        for single-cell omics data
      </p>
</li>
<li style="list-style-type: none;">
  <h4>Teaching</h4>
  <ul style="font-size: 16px;margin: 0; text-align: left; padding:0px">
    <li style="list-style-type: none;">
      <p style="height: 70px; margin:0px; text-align: left; font-size: 16px; margin-bottom: 0px">
        Foundation of Artificial Intelligence (Undergraduate), Instructor
      </p>
    </li>
    <li style="list-style-type: none;">
      <p style="height: 70px;margin:0px; text-align: left; font-size: 16px; margin-bottom: 0px">
        Data Science and Knowledge Discovery (Graduate), Instructor
      </p>
    </li>
    <li style="list-style-type: none;">
      <p style="height: 80px;margin:0px; text-align: left; font-size: 16px; margin-bottom: 0px">
        Statistical Methods with Applications (2014, 2015) Teaching assistant, Tsinghua University
      </p>
    </li>
  </ul>
</li>
<li style="list-style-type: none;">
  <h4>Presentations</h4>
  <div style="font-size: 16px">
<!-- 第一行内容 -->
<div style="display: flex;flex-direction: column;">
<div style="text-align: left;"><b>· 2021.07</b> </div>
<pre style="height:70px; text-align: left; font-family: 'Arial'; font-size: 16px; margin-top: 0px; margin-bottom: 0px;white-space: pre-wrap;">
Invited talk, Chinese Society of Biotechnology Young Scientists Forum V
</pre>
</div>

<!-- 第二行内容 -->
<div style="display: flex;flex-direction: column;margin-top: 20px;">
<div style="text-align: left;"><b>· 2021.01</b></div>
<pre style="height:70px; text-align: left; font-family: 'Arial'; font-size: 16px; margin-top: 0px; margin-bottom: 0px;white-space: pre-wrap;">
Invited talk, Chinese Academy of Medical Sciences & Peking Union Medical College
</pre>
</div>

<!-- 第三行内容 -->
<div style="display: flex;flex-direction: column;margin-top: 20px;">
<div style="text-align: left;"><b>· 2019.04</b> </div>
<pre style="height:70px; text-align: left; font-family: 'Arial'; font-size: 16px; margin-top: 0px; margin-bottom: 0px;white-space: pre-wrap;">
Invited talk, Department of Medical informatics, Peking University Health Science Center
</pre>
</div>

<!-- 第四行内容 -->
<div style="display: flex;flex-direction: column;margin-top: 20px;">
<div style="text-align: left;"><b>· 2019.02</b> </div>
<pre style="height:84px; text-align: left; font-family: 'Arial'; font-size: 16px; margin-top: 0px; margin-bottom: 0px;white-space: pre-wrap;">
Invited talk, Department of Medical informatics, Peking University Health Science Center
</pre>
</div>

<!-- 第五行内容 -->
<div style="display: flex;flex-direction: column;margin-top: 20px;">
<div style="text-align: left;"><b>· 2019.01</b> </div>
<pre style="height:84px; text-align: left; font-family: 'Arial'; font-size: 16px; margin-top: 0px; margin-bottom: 0px;white-space: pre-wrap;">
Invited talk, Beijing Proteome Research Center
</pre>
</div>

<!-- 第六行内容 -->
<div style="display: flex;flex-direction: column;margin-top: 20px;">
<div style="text-align: left;"><b>· 2018.11</b> </div>
<pre style="height:84px; text-align: left; font-family: 'Arial'; font-size: 16px; margin-top: 0px; margin-bottom: 0px;white-space: pre-wrap;">
Poster, Cold Spring Harbor Asia meeting on Frontiers in Single cell Genomics
</pre>
</div>

<!-- 第七行内容 -->
<div style="display: flex;flex-direction: column;margin-top: 20px;">
<div style="text-align: left;"><b>· 2018.10</b> </div>
<pre style="height:84px; text-align: left; font-family: 'Arial'; font-size: 16px; margin-top: 0px; margin-bottom: 0px;white-space: pre-wrap;">
Invited talk, Department of Medical informatics, Peking University Health Science Center
</pre>
</div>

<!-- 第八行内容 -->
<div style="display: flex;flex-direction: column;margin-top: 20px;">
<div style="text-align: left;"><b>· 2018.08</b> </div>
<pre style="height:84px; text-align: left; font-family: 'Arial'; font-size: 16px; margin-top: 0px; margin-bottom: 0px;white-space: pre-wrap;">
Talk & Poster, Pilot Projects for a Human Cell Atlas Europe Retreat
</pre>
</div>

<!-- 第九行内容 -->
<div style="display: flex;flex-direction: column;margin-top: 20px;">
<div style="text-align: left;"><b>· 2018.04</b> </div>
<pre style="height:84px; text-align: left; font-family: 'Arial'; font-size: 16px; margin-top: 0px; margin-bottom: 0px;white-space: pre-wrap;">
Invited talk, Department of Medical informatics, Peking University Health Science Center
</pre>
</div>

<!-- 第十行内容 -->
<div style="display: flex;flex-direction: column;margin-top: 20px;">
<div style="text-align: left;"><b>· 2017.11</b> </div>
<pre style="height:84px; text-align: left; font-family: 'Arial'; font-size: 16px; margin-top: 0px; margin-bottom: 0px;white-space: pre-wrap;">
Invited talk, Institute of Computing Technology, Chinese Academy of Sciences
</pre>
</div>

<!-- 第十一行内容 -->
<div style="display: flex;flex-direction: column;margin-top: 20px;">
<div style="text-align: left;"><b>· 2016.11</b> </div>
<pre style="height:84px; text-align: left; font-family: 'Arial'; font-size: 16px; margin-top: 0px; margin-bottom: 0px;white-space: pre-wrap;">
Poster, Cold Spring Harbor Asia meeting on Frontiers in Single cell Genomics
</pre>
</div>
</div>

</li>
</ul>
</div>

    <div v-if="!isMobile" v-show="language === 'English'" style="font-size: 30px">
      <ul style="padding:0px">
        <li style="list-style-type: none;">
          <h4>工作经历</h4>
          <div style="font-size: 16px">

            <div style="font-size: 16px">
              <div style="display: flex">
                <div style="text-align: left; width:230px; font-size: 16px">2023.12-至今</div>
                <pre style="height:40px; text-align: left; font-family: 'Arial'; font-size: 16px; margin-top: 0px; margin-bottom: 0px">
北京交通大学 软件工程学院 <b>副教授</b>
            </pre>
              </div>
            </div>

            <div style="font-size: 16px">
              <div style="display: flex">
                <div style=" margin-top:0px; text-align: left; width:230px; font-size: 16px">2023.01-2024.01</div>
                <pre style="height:40px; text-align: left; font-family: 'Arial'; font-size: 16px; margin-top: 0px; margin-bottom: 0px">
英国剑桥Sanger研究所 <b>访问学者</b>
            </pre>
              </div>
            </div>
            <div style="font-size: 16px">
              <div style="display: flex">
                <div style=" margin-top:0px; text-align: left; width:230px;font-size: 16px">2019.07-2023.12</div>
                <pre style="height:40px; text-align: left; font-family: 'Arial'; font-size: 16px; margin-top: 0px; margin-bottom: 0px">
北京交通大学 软件学院 <b>讲师</b> 硕士生导师
            </pre>
              </div>
            </div>
          </div>
        </li>
        <li style="list-style-type: none;">
          <h4>教育背景</h4>
          <div style="font-size: 16px">
            <div style="font-size: 16px">
              <div style="display: flex">
                <div style=" text-align: left; width:230px; font-size: 16px">2013.09-2019.07</div>
                <pre style="height:90px; text-align: left; font-family: 'Arial'; font-size: 16px; margin-top: 0px; margin-bottom: 0px">
<b>清华大学 自动化系 控制科学与工程博士(方向：生物信息学)</b>
导师：张学工 & Michael Q. Zhang
论文题目：单细胞转录组的计算方法学研究
            </pre>
              </div>
            </div>

            <div style="font-size: 16px">
              <div style="display: flex">
                <div style="text-align: left; width:230px; font-size: 16px">2009.09-2013.07</div>
                <pre style="height:40px; text-align: left; font-family: 'Arial'; font-size: 16px; margin-top: 0px; margin-bottom: 0px">
<b>吉林大学 数学学院 统计学学士</b>
            </pre>
              </div>
            </div>
          </div>
        </li>

        <li style="list-style-type: none;">
          <h4>科研项目</h4>
          <ul style="margin-top: 10px; font-size: 16px; text-align: left; padding: 0px">
            <li style="list-style-type: none;">
              <p style="height: 40px; margin:0px;text-align: left; font-size: 16px">
                <b>国家自然科学基金青年项目：</b>整合单细胞转录组数据与空间转录组数据的细胞异质性分析方法, 2021-01 至 2023-12， 主持
              </p>
            </li>
            <li style="list-style-type: none;">
              <p style="height: 40px;margin:0px; text-align: left; font-size: 16px">
                <b>中央高校基本科研业务费人才基金项目：</b>单细胞组学数据的表示学习, 
2019-04 至 2024-09, 主持
              </p>
            </li>
          </ul>
        </li>
        <li style="list-style-type: none;">
          <h4>教学经历</h4>
          <ul style="font-size: 16px; text-align: left; padding: 0px">
            <li style="list-style-type: none;">
              <p style="height: 40px;margin:0px; text-align: left; font-size: 16px">
                《人工智能基础》（本科课程）
              </p>
            </li>
            <li style="list-style-type: none;">
              <p style="height: 40px;margin:0px; text-align: left; font-size: 16px">
                《算法设计与实践》（本科课程）
              </p>
            </li>
            <li style="list-style-type: none;">
              <p style="height: 40px;margin:0px; text-align: left; font-size: 16px">
                《数据科学与知识发现》（研究生课程）
              </p>
            </li>
            <li style="list-style-type: none;">
              <p style="height: 40px;margin:0px; text-align: left; font-size: 16px">
                《统计方法与应用》（清华大学自动化系课程助教，2014，2015）
              </p>
            </li>
          </ul>
        </li>
        <li style="list-style-type: none;">
          <h4>学术报告</h4>
          <div style="font-size: 16px">
            <div style="display: flex">
              <div style=" text-align: left; width: 100px; font-size: 16px">2021.07</div>
              <pre style="height:40px; text-align: left; font-family: 'Arial'; font-size: 16px; margin-top: 0px; margin-bottom: 0px">
报告，中国生物工程学会第五届青年科技论坛
            </pre>
            </div>
            <div style="display: flex">
              <div style=" text-align: left; width: 100px; font-size: 16px">2021.01</div>
              <pre style="height:40px; text-align: left; font-family: 'Arial'; font-size: 16px; margin-top: 0px; margin-bottom: 0px">
邀请报告，北京协和医学院
            </pre>
            </div>
            <div style="display: flex">
              <div style=" text-align: left; width: 100px; font-size: 16px">2019.04</div>
              <pre style="height:40px; text-align: left; font-family: 'Arial'; font-size: 16px; margin-top: 0px; margin-bottom: 0px">
邀请报告, 北京大学医学部，医学信息学系
            </pre>
            </div>
            <div style="display: flex">
              <div style=" text-align: left; width: 100px; font-size: 16px">2019.02</div>
              <pre style="height:40px; text-align: left; font-family: 'Arial'; font-size: 16px; margin-top: 0px; margin-bottom: 0px">
邀请报告, 北京大学医学部，医学信息学系
            </pre>
            </div>
            <div style="display: flex">
              <div style=" text-align: left; width: 100px; font-size: 16px">2019.01</div>
              <pre style="height:40px; text-align: left; font-family: 'Arial'; font-size: 16px; margin-top: 0px; margin-bottom: 0px">
邀请报告, 国家蛋白质科学中心·北京
            </pre>
            </div>
            <div style="display: flex">
              <div style=" text-align: left; width: 100px; font-size: 16px">2018.11</div>
              <pre style="height:40px; text-align: left; font-family: 'Arial'; font-size: 16px; margin-top: 0px; margin-bottom: 0px">
海报, Cold Spring Harbor Asia meeting on Frontiers in Single cell Genomics
            </pre>
            </div>
            <div style="display: flex">
              <div style=" text-align: left; width: 100px; font-size: 16px">2018.10</div>
              <pre style="height:40px; text-align: left; font-family: 'Arial'; font-size: 16px; margin-top: 0px; margin-bottom: 0px">
邀请报告, 北京大学医学部，医学信息学系
            </pre>
            </div>
            <div style="display: flex">
              <div style=" text-align: left; width: 100px; font-size: 16px">2018.08</div>
              <pre style="height:40px; text-align: left; font-family: 'Arial'; font-size: 16px; margin-top: 0px; margin-bottom: 0px">
报告&海报, Pilot Projects for a Human Cell Atlas Europe Retreat
            </pre>
            </div>
            <div style="display: flex">
              <div style=" text-align: left; width: 100px; font-size: 16px">2018.04</div>
              <pre style="height:40px; text-align: left; font-family: 'Arial'; font-size: 16px; margin-top: 0px; margin-bottom: 0px">
邀请报告, 北京大学医学部，医学信息学系
            </pre>
            </div>
            <div style="display: flex">
              <div style=" text-align: left; width: 100px; font-size: 16px">2017.11</div>
              <pre style="height:40px; text-align: left; font-family: 'Arial'; font-size: 16px; margin-top: 0px; margin-bottom: 0px">
邀请报告, 中科院计算技术研究所
            </pre>
            </div>
            <div style="display: flex">
              <div style=" text-align: left; width: 100px; font-size: 16px">2016.11</div>
              <pre style="height:40px; text-align: left; font-family: 'Arial'; font-size: 16px; margin-top: 0px; margin-bottom: 0px">
海报, Cold Spring Harbor Asia meeting on Frontiers in Single cell Genomics
            </pre>
            </div>
          </div>
        </li>
      </ul>
    </div>




    <!-- 手机布局 -->
    <div v-else v-show="language === 'English'">
      <ul style="padding:0px">
        <li style="list-style-type: none;">
          <h4>工作经历</h4>
          <div style="font-size: 15px">

            <div>
              <div style="display: flex;flex-direction: column;">
                <div style=" text-align: left; width:230px; font-size: 15px">· 2023.12-至今</div>
                <pre style="height:40px; text-align: left; font-family: 'Arial'; font-size: 15px; margin-top: 0px; margin-bottom: 0px">
北京交通大学 软件工程学院 <b>副教授</b>
            </pre>
              </div>
            </div>

            <div style="font-size: 15px">
              <div style="display: flex;flex-direction: column;">
                <div style=" margin-top:0px; text-align: left; width:230px; font-size: 15px">· 2023.01-2024.01</div>
                <pre style="height:40px; text-align: left; font-family: 'Arial'; font-size: 15px; margin-top: 0px; margin-bottom: 0px">
英国剑桥Sanger研究所 <b>访问学者</b>
            </pre>
              </div>
            </div>
            <div style="font-size: 15px">
              <div style="display: flex;flex-direction: column;">
                <div style=" margin-top:0px; text-align: left; width:230px;font-size: 15px">· 2019.07-2023.12</div>
                <pre style="height:40px; text-align: left; font-family: 'Arial'; font-size: 15px; margin-top: 0px; margin-bottom: 0px">
北京交通大学 软件学院 <b>讲师</b> 硕士生导师
            </pre>
              </div>
            </div>
          </div>
        </li>
        <li style="list-style-type: none;">
          <h4>教育背景</h4>
          <div style="font-size: 15px">
            <div style="font-size: 15px">
              <div style="display: flex;flex-direction: column;">
                <div style=" text-align: left; width:230px; font-size: 15px">· 2013.09-2019.07</div>
                <pre style=" text-align: left; font-family: 'Arial';font-size: 15px; margin-top: 0px; margin-bottom: 0px;white-space: pre-wrap">
<b>清华大学 自动化系 控制科学与工程博士(方向：生物信息学)</b>
导师:张学工 & Michael Q. Zhang
论文题目:单细胞转录组的计算方法学研究
            </pre>
              </div>
            </div>

            <div style="font-size: 15px">
              <div style="display: flex;flex-direction: column;gap: 0px;">
                <div style="text-align: left; width:230px; font-size: 15px">· 2009.09-2013.07</div>
                <pre style="height:auto; text-align: left; font-family: 'Arial'; font-size: 15px; margin-top: 0px; margin-bottom: 0px">
<b>吉林大学 数学学院 统计学学士</b>
            </pre>
              </div>
            </div>
          </div>
        </li>

        <li style="list-style-type: none;">
          <h4>科研项目</h4>
          <ul style="margin-top: 10px; font-size: 15px; text-align: left; padding: 0px">
            <li style="list-style-type: none;">
              <p style="height: auto; margin:0px;text-align: left; font-size: 15px">
                <b>国家自然科学基金青年项目：</b>整合单细胞转录组数据与空间转录组数据的细胞异质性分析方法, 2021-01 至 2023-12， 主持
              </p>
            </li>
            <li style="list-style-type: none;">
              <p style="height: auto;margin:0px; text-align: left; font-size: 15px;margin-top: 20px;">
                <b>中央高校基本科研业务费人才基金项目：</b>单细胞组学数据的表示学习, 
2019-04 至 2024-09, 主持
              </p>
            </li>
          </ul>
        </li>
        <li style="list-style-type: none;">
          <h4>教学经历</h4>
          <ul style="font-size: 16px; text-align: left; padding: 0px">
            <li style="list-style-type: none;">
              <p style="height: 40px;margin:0px; text-align: left; font-size: 15px">
                《人工智能基础》（本科课程）
              </p>
            </li>
            <li style="list-style-type: none;">
              <p style="height: 40px;margin:0px; text-align: left; font-size: 15px">
                《算法设计与实践》（本科课程）
              </p>
            </li>
            <li style="list-style-type: none;">
              <p style="height: 40px;margin:0px; text-align: left; font-size: 15px">
                《数据科学与知识发现》（研究生课程）
              </p>
            </li>
            <li style="list-style-type: none;">
              <p style="height: 50px;margin:0px; text-align: left; font-size: 15px;">
                《统计方法与应用》（清华大学自动化系课程助教，2014，2015）
              </p>
            </li>
          </ul>
        </li>
        <li style="list-style-type: none;">
          <h4>学术报告</h4>
          <div style="font-size: 15px">
            <div style="display: flex;flex-direction: column;">
              <div style=" text-align: left; width: 100px; font-size: 15px">· 2021.07</div>
              <pre style="height:auto; text-align: left; font-family: 'Arial'; font-size: 15px; margin-top: 0px; margin-bottom: 0px; white-space: pre-wrap;">
报告，中国生物工程学会第五届青年科技论坛
            </pre>
            </div>
            <div style="display: flex;flex-direction: column;">
              <div style=" text-align: left; width: 100px; font-size: 15px">· 2021.01</div>
              <pre style="height:auto; text-align: left; font-family: 'Arial'; font-size: 15px; margin-top: 0px; margin-bottom: 0px; white-space: pre-wrap;">
邀请报告，北京协和医学院
            </pre>
            </div>
            <div style="display: flex;flex-direction: column;">
              <div style=" text-align: left; width: 100px; font-size: 15px">· 2019.04</div>
              <pre style="height:60px; text-align: left; font-family: 'Arial'; font-size: 15px; margin-top: 0px; margin-bottom: 0px; white-space: pre-wrap;">
邀请报告, 北京大学医学部，医学信息学系
            </pre>
            </div>
            <div style="display: flex;flex-direction: column;">
              <div style=" text-align: left; width: 100px; font-size: 15px">· 2019.02</div>
              <pre style="height:60px; text-align: left; font-family: 'Arial'; font-size: 15px; margin-top: 0px; margin-bottom: 0px; white-space: pre-wrap;">
邀请报告, 北京大学医学部，医学信息学系
            </pre>
            </div>
            <div style="display: flex;flex-direction: column;">
              <div style=" text-align: left; width: 100px; font-size: 15px">· 2019.01</div>
              <pre style="height:auto; text-align: left; font-family: 'Arial'; font-size: 15px; margin-top: 0px; margin-bottom: 0px; white-space: pre-wrap;">
邀请报告, 国家蛋白质科学中心·北京
            </pre>
            </div>
            <div style="display: flex;flex-direction: column;">
              <div style=" text-align: left; width: 100px; font-size: 15px">· 2018.11</div>
              <pre style="height:90px; text-align: left; font-family: 'Arial'; font-size: 15px; margin-top: 0px; margin-bottom: 0px; white-space: pre-wrap;">
海报, Cold Spring Harbor Asia meeting on Frontiers in Single cell Genomics
            </pre>
            </div>
            <div style="display: flex;flex-direction: column;">
              <div style=" text-align: left; width: 100px; font-size: 15px">· 2018.10</div>
              <pre style="height:70px; text-align: left; font-family: 'Arial'; font-size: 15px; margin-top: 0px; margin-bottom: 0px; white-space: pre-wrap;">
邀请报告, 北京大学医学部，医学信息学系
            </pre>
            </div>
            <div style="display: flex;flex-direction: column;">
              <div style=" text-align: left; width: 100px; font-size: 15px">· 2018.08</div>
              <pre style="height:auto; text-align: left; font-family: 'Arial'; font-size: 15px; margin-top: 0px; margin-bottom: 0px; white-space: pre-wrap;">
报告&海报, Pilot Projects for a Human Cell Atlas Europe Retreat
            </pre>
            </div>
            <div style="display: flex;flex-direction: column;">
              <div style=" text-align: left; width: 100px; font-size: 15px">· 2018.04</div>
              <pre style="height:55px; text-align: left; font-family: 'Arial'; font-size: 15px; margin-top: 0px; margin-bottom: 0px; white-space: pre-wrap;">
邀请报告, 北京大学医学部，医学信息学系
            </pre>
            </div>
            <div style="display: flex;flex-direction: column;">
              <div style=" text-align: left; width: 100px; font-size: 15px">· 2017.11</div>
              <pre style="height:auto; text-align: left; font-family: 'Arial'; font-size: 15px; margin-top: 0px; margin-bottom: 0px; white-space: pre-wrap;">
邀请报告, 中科院计算技术研究所
            </pre>
            </div>
            <div style="display: flex;flex-direction: column;">
              <div style=" text-align: left; width: 100px; font-size: 15px">· 2016.11</div>
              <pre style="height:auto; text-align: left; font-family: 'Arial'; font-size: 15px; margin-top: 0px; margin-bottom: 0px; white-space: pre-wrap;">
海报, Cold Spring Harbor Asia meeting on Frontiers in Single cell Genomics
            </pre>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div style="height: 40px"/>
  </div>
</template>

<script>
// import Resume from './Resume'
export default {
  name: 'Teacher',
  // components: {Resume},
  data () {
    return {
      language: '中文',
      isMobile: false,
    }
  },
  methods: {
    changeLanguage () {
      if (this.language === '中文') {
        this.language = 'English'
      } else {
        this.language = '中文'
      }
    },
    checkScreenSize() {
      // 判断屏幕宽度是否小于768px
      this.isMobile = window.innerWidth < 768;
    },
    goTeacherPage () {
      this.$router.push({ path: '/Teacher' })
    }
  },
  mounted() {
    // 初始化屏幕宽度检测
    this.checkScreenSize();
    // 监听窗口大小变化
    window.addEventListener("resize", this.checkScreenSize);
  },
  beforeDestroy() {
    // 移除事件监听器
    window.removeEventListener("resize", this.checkScreenSize);
  },
}
</script>

<style scoped>
#language_div{
  position: relative;
  width: 60px;
  right: -90%;
  margin-top: 20px;
  font-size: 20px;
  text-decoration:underline
}

#language_div:hover{
  cursor: pointer;
  color: blue;
}

.titles{
  color: #005BAC;
  text-align: left;
  margin: 16px 0 0 0;
  padding: 0;
}

h4 {
  text-align: left;
  color: white;
  background-color: #005BAC;
  width: 100%;
  margin-bottom: 5px;
  margin-top: 5px;
  text-indent: 16px;
}

.p-common {
  line-height: 30px;
  text-align: justify;
  text-indent: 2em;
  font-size: 16px;
}

.time_p {
  text-align: left;
  color: #005BAC;
  font-family: "Arial";
  font-size: 16px;
  font-weight: bold;
  width: 60%;
}
h4{
  font-size: 25px;
}
.time_content_p {
  width: 100%;
  text-align: left;
}

.flex_horizon {
  display: flex;
  align-items: center;
  justify-content: space-around;
  justify-items: center;
}
#teachers{
  width: 1000px;
  margin:auto;
}

@media (max-width: 768px) {
  #teachers{
    width: 80%;
    margin:auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components2/Teacher.vue